/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentTransferDto
 */
export interface NovitusPaymentTransferDto {
    /**
     * Nazwa formy płatności przelewem bankowym
     * @type {string}
     * @memberof NovitusPaymentTransferDto
     */
    name?: string;
    /**
     * Wartość płatności przelewem jako string numeryczny
     * @type {string}
     * @memberof NovitusPaymentTransferDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentTransferDto interface.
 */
export function instanceOfNovitusPaymentTransferDto(value: object): value is NovitusPaymentTransferDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentTransferDtoFromJSON(json: any): NovitusPaymentTransferDto {
    return NovitusPaymentTransferDtoFromJSONTyped(json, false);
}

export function NovitusPaymentTransferDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentTransferDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'],
    };
}

export function NovitusPaymentTransferDtoToJSON(value?: NovitusPaymentTransferDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

